import React from "react";
import logo_footer from "../assets/img/logo-footer.png";

export default function Foother() {
  const fecha = new Date();
  const ano = fecha.getFullYear();
  return (
    <div style={{ paddingBottom: 10 }}>
      Powered by{" "}
      <img
        src={logo_footer}
        alt="Imagen Logo"
        style={{ height: "20px", padding: "2px, 5px, 0px, 2px" }}
      />{" "}
      ©{ano}
    </div>
  );
}
